import React from "react";
import { AssessmentHeader } from "../assessment/AssessmentHeader";
import { QuizAssessmentBody } from "./QuizAssessmentBody";
import { AssessmentDescription } from "./AssessmentDescription";
import { AssessmentInfoPage } from "./AssessmentInfoPage";
import { useState, useEffect } from "react";
import { Row } from "reactstrap";
import { AssessmentBottomPanel } from "./AssessmentBottomPanel";
import {
  assessmentType,
  assessmentFlow,AccountType,
} from "../../components/constants/constants";
import { find, size } from "lodash";

import { PlacementProgressbar } from "./PlacementProgressbar";
import { CustomPagination } from "./CustomPagination";
let visited_pages = [];
let pagination_color_decision = [];
export const AssessmentRunner = ({
  isReview,
  data,
  isStopTimer,
  setIsStopTimer,
  IsonRecorder,
  setIsonRecorder,
  timer,
  isOpenAdditionalResourceModal,
  setOpenAdditionalResourceModal,
  additionalResourceToggle,
  setSpeakingUrl,
  currentPage,
  onblur,
  answers,
  resetAudio,
  setresetAudio,
  setCurrentPage,
  creatQuizDataAndSubmit,
  isSubmitting,
  setShowTimeWarning,
  showTimeWarning,
  visualizerToggle,
}) => {
  const [assessmentData, setAssessmentData] = useState(data);
  const [ShowAssessmentInfo,setShowAssessmentInfo] = useState(true);
  const [hideBottomPanel,sethideBottomPanel] = useState(false);
  useEffect(() => {
    setAssessmentData(data);
  }, [data]);
  const [CurrentSection, setCurrentSection] = useState(1);
  const [currentPageOfSection, setCurrentPageOfSection] =
    useState(CurrentSection);

  const [currentSectionPage, setcurrentSectionPage] = useState(11);
  const [currentSectionPageOnSection, setcurrentSectionPageOnSection] =
    useState(currentSectionPage);

  useEffect(() => {
    setcurrentSectionPageOnSection(currentSectionPage);
  }, [currentSectionPage]);

  useEffect(() => {
    setCurrentPageOfSection(CurrentSection);
  }, [CurrentSection]);

  useEffect(() => {
    if (
      data.completed_at &&
      data.completed_at !== null && data.sections
    ) {
        setCurrentSection(data.sections[0].section_number);
        setcurrentSectionPage((`${data.sections[0].section_number}1`));
      }
  }, [data]);

  if (
    data.completed_at &&
    data.completed_at !== null
  ) {
      isReview = true;
      setIsStopTimer(true);
  }
  let bottomPanelSection;
  let bottomPanelPage;
  let pagesOfCurrentSection;
  // let lastSectionNumber;
  return (
    <div data-tc="assessment-start-page">
      <div className="Header">
        <AssessmentHeader
          creatQuizDataAndSubmit={creatQuizDataAndSubmit}
          isReview={isReview}
          data={assessmentData}
          isStopTimer={isStopTimer}
          setIsStopTimer={setIsStopTimer}
          timer={timer}
          setShowTimeWarning={setShowTimeWarning}
          showTimeWarning={showTimeWarning}
        />
      </div>
      <div className="Question__description">
        <AssessmentDescription data={assessmentData} />
        {assessmentData &&
          assessmentData.sections &&
          assessmentData.sections.map((section, id) => {
            // lastSectionNumber = section.section_number;
            if (
              parseInt(currentPageOfSection) ===
              parseInt(section.section_number) || (assessmentData.assessment_flow === assessmentFlow.SEQUENTIAL_EARLY_STOP && data.user_type === AccountType.STUDENT  && !isReview)
            ) {
              if(!ShowAssessmentInfo){
                localStorage.setItem(`ShowInfo${section.id}`,true);
                setShowAssessmentInfo(true);
              }
              if(section.instruction !== "" && !section.show_instruction_on_this_page && !localStorage.getItem(`ShowInfo${section.id}`))
              {
                return ( 
                <AssessmentInfoPage
                  sethideBottomPanel={sethideBottomPanel}
                  instruction={section.instruction}
                  setShowAssessmentInfo={setShowAssessmentInfo}
                />
                );
              }
              return (
                section &&
                section.pages.map((page, id) => {

                if(section.instruction !== "" && section.show_instruction_on_this_page === page.page_number && !localStorage.getItem(`ShowInfo${section.id}`))
                  {
                    if( parseInt(currentSectionPageOnSection) === parseInt(`${section.section_number}${section.show_instruction_on_this_page}`)  ||  (assessmentData.assessment_flow === assessmentFlow.SEQUENTIAL_EARLY_STOP && data.user_type === AccountType.STUDENT && !isReview))
                    {
                      if(section.show_instruction_on_this_page === page.page_number)
                      {
                        return (
                          
                          <AssessmentInfoPage
                            sethideBottomPanel={sethideBottomPanel}
                            instruction={section.instruction}
                            setShowAssessmentInfo={setShowAssessmentInfo}
                          />
                        );
                      }
                    }
                  }
                  else{
                    if (
                      parseInt(currentSectionPageOnSection) ===
                      parseInt(`${section.section_number}${page.page_number}`) || (assessmentData.assessment_flow === assessmentFlow.SEQUENTIAL_EARLY_STOP && data.user_type === AccountType.STUDENT && !isReview)
                    ) 
                    {
                      pagesOfCurrentSection = section.total_pages;
                      bottomPanelSection = section.section_number;
                      bottomPanelPage = page.page_number;
                      if (page.writing_exercises.length === 0) {
                        return (
                          page &&
                          page.exercises.map((exercise, exercise_id) => {
                            let found_selected_answer = find(visited_pages, [
                              "section_number",
                              section.section_number,
                            ]);
                            if (found_selected_answer) {
                              let found_exercise = find(
                                found_selected_answer.pages,
                                ["exercise_id", exercise.id]
                              );
                              if (!found_exercise) {
                                found_selected_answer.pages.push({
                                  exercise_total_questions: size(
                                    exercise.questions
                                  ),
                                  page_number: page.page_number,
                                  exercise_questions: exercise.questions,
                                  page_id: page.id,
                                  exercise_id: exercise.id,
                                  pagination_number: currentSectionPage,
                                });
                              }
                            } else {
                              visited_pages.push({
                                section_number: section.section_number,
                                pages: [
                                  {
                                    exercise_total_questions: size(
                                      exercise.questions
                                    ),
                                    page_number: page.page_number,
                                    exercise_questions: exercise.questions,
                                    page_id: page.id,
                                    exercise_id: exercise.id,
                                    pagination_number: currentSectionPage,
                                  },
                                ],
                              });
                            }
  
                            return (
                              <QuizAssessmentBody
                                section_id={section.id}
                                page_id={page.id}
                                exercise={exercise}
                                setIsonRecorder= {setIsonRecorder}
                                isReview={isReview}
                                setOpenAdditionalResourceModal={
                                  setOpenAdditionalResourceModal
                                }
                                isOpenAdditionalResourceModal={
                                  isOpenAdditionalResourceModal
                                }
                                additionalResourceToggle={
                                  additionalResourceToggle
                                }
                                resetAudio={resetAudio}
                                setresetAudio={setresetAudio}
                                setSpeakingUrl={setSpeakingUrl}
                                currentPage={currentPage}
                                onblur={onblur}
                                answers={answers}
                                data={assessmentData}
                                visualizerToggle={visualizerToggle}
                              />
                            );
                          })
                        );
                      } else {
                        return (
                          page &&
                          page.writing_exercises.map((exercise, exercise_id) => {
                            let found_selected_answer = find(visited_pages, [
                              "section_number",
                              section.section_number,
                            ]);
                            if (found_selected_answer) {
                              let found_exercise = find(
                                found_selected_answer.pages,
                                ["exercise_id", exercise.id]
                              );
                              if (!found_exercise) {
                                found_selected_answer.pages.push({
                                  exercise_total_questions: size(
                                    exercise.questions
                                  ),
                                  page_number: page.page_number,
                                  exercise_questions: exercise.questions,
                                  page_id: page.id,
                                  exercise_id: exercise.id,
                                  pagination_number: currentSectionPage,
                                });
                              }
                            } else {
                              visited_pages.push({
                                section_number: section.section_number,
                                pages: [
                                  {
                                    exercise_total_questions: size(
                                      exercise.questions
                                    ),
                                    page_number: page.page_number,
                                    exercise_questions: exercise.questions,
                                    page_id: page.id,
                                    exercise_id: exercise.id,
                                    pagination_number: currentSectionPage,
                                  },
                                ],
                              });
                            }
  
                            return (
                              <QuizAssessmentBody
                                section_id={section.id}
                                page_id={page.id}
                                setIsonRecorder= {setIsonRecorder}
                                exercise={exercise}
                                isReview={isReview}
                                setOpenAdditionalResourceModal={
                                  setOpenAdditionalResourceModal
                                }
                                isOpenAdditionalResourceModal={
                                  isOpenAdditionalResourceModal
                                }
                                additionalResourceToggle={
                                  additionalResourceToggle
                                }
                                setSpeakingUrl={setSpeakingUrl}
                                currentPage={currentPage}
                                resetAudio={resetAudio}
                                setresetAudio={setresetAudio}
                                onblur={onblur}
                                answers={answers}
                                data={assessmentData}
                              />
                            );
                          })
                        );
                      }
                    }
                  }
                  
                })
              );
            }
          })}
      </div>
      {hideBottomPanel ? null :
      (
        <>
          {isReview ||
            assessmentData.assessment_flow ===
              assessmentFlow.SEQUENTIAL_EARLY_STOP ? null : assessmentData.assessment_type ===
              assessmentType.PLACEMENT ? (
              <>
                <PlacementProgressbar
                  data={assessmentData}
                  answers={answers}
                  visited_pages={visited_pages}
                  currentPage={CurrentSection}
                  setCurrentPage={setCurrentSection}
                  currentSectionPage={currentSectionPage}
                  setCurrentSectionPage={setcurrentSectionPage}
                  pagination_color_decision={pagination_color_decision}
                />
              </>
            ) : (
              <>
                <CustomPagination
                  data={assessmentData}
                  answers={answers}
                  visited_pages={visited_pages}
                  currentPage={CurrentSection}
                  setCurrentPage={setCurrentSection}
                  currentSectionPage={currentSectionPage}
                  setCurrentSectionPage={setcurrentSectionPage}
                  pagination_color_decision={pagination_color_decision}
                />
              </>
          )}
          <Row className="border bg-white border-top-0 px-4 p-3 rounded-footer">
            <AssessmentBottomPanel
              data={assessmentData}
              IsonRecorder={IsonRecorder}
              pagesOfCurrentSection={pagesOfCurrentSection}
              currentSection={bottomPanelSection}
              setCurrentSection={setCurrentSection}
              currentSectionPage={bottomPanelPage}
              setCurrentSectionPage={setcurrentSectionPage}
              total_sections={assessmentData && assessmentData.sections && assessmentData.sections.length}
              isSubmitting={isSubmitting}
              isReview={isReview}
            />
          </Row>
        </>
      )}

    </div>
  );
};
